const PercentageBar = ({ percentage }: { percentage: number }) => {
  const totalLeftBars = 20;

  const filledBars = Math.round((percentage / 100) * totalLeftBars);
  console.log(percentage);

  const genColor = () => {
    if (percentage >= 50) {
      return '#99D633';
    }
    if (percentage >= 20 && percentage < 50) {
      return '#FDBD4D';
    }
    else {
      return '#FF5233';
    }
  };

  const leftBars = Array.from({ length: totalLeftBars }, (_, i) => (
    <div
      key={`left-${i}`}
      className="bar"
      style={{
        backgroundColor: i < filledBars ? genColor() : "#FFFFFF",
        flex: 1,
        height: "100%",
      }}
    />
  ));
  return (
    <div
      style={{
        display: "flex",
        backgroundColor: "#0D2B3E",
        padding: "5px",
        gap: "3px",
      }}
      className='w-[140px] h-[25px] 2xl:w-[150px] 2xl:h-[40px]'
    >
      {leftBars}
    </div>
  );
};

export default PercentageBar;